import { helpers } 		from './theme/helpers.js';
import { cacheLogic } 		from './theme/components/cache-logic.js';
import { hamburger } 		from './theme/components/hamburger.js';


jQuery.fn.isInViewport = function() {
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight();
  
	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height();
  
	return elementBottom > viewportTop && elementTop < viewportBottom;
  };
window.theme = {
	globals: {
		isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
		isTabActive: true,
	},
	
	init: function () {
		var self = this;

		hamburger.init();

		// Global
		self.onloadClass();
		self.touch();
		self.smoothScroll.init();

		self.rated();
		self.updatePortions();
		self.galleryClose();
		self.iLikePost();
		self.iLikeTutorial();
		self.printPage();
		self.popupBasicCalls();

		self.inlineYoutube();

		self.moveRating();

		self.galleryBodyOverflow();
		self.showGalleryRelated();

		self.showMoreArticles();

		self.ratingNotLogged();

		self.checkResponsHeader();

		cacheLogic.init();
	},

	checkResponsHeader( ) {
		if( jQuery( window ).width() <= 782 ) {
			if( jQuery( document ).scrollTop() <= 43 ) {
				jQuery( ".header" ).removeClass('fixed');
			}
			else {
				jQuery( ".header" ).addClass('fixed');
			}
		}
	},

	showGalleryRelated( ) {
		jQuery( document ).on('click', '.js-showGalleryRelated', function(e) {
			e.preventDefault();
			jQuery(".js-showGalleryRelated").addClass("hide-last");
			jQuery(".gallery__related").addClass("active");
			jQuery(".gallery__inner").hide();
		});
	},

	galleryBodyOverflow( ) {
		if( jQuery( ".gallery").length ) {
			jQuery( "body" ).addClass( 'overflow-hidden' );
		}
	},

    ratingNotLogged() {
        var self = this;

        jQuery(document).on('click', 'body:not(.logged-in) .rmp-rating-widget, body:not(.logged-in) .rmp-rate-view, body:not(.logged-in) .rating-stars, body:not(.logged-in) .rmp-icon', function(e) {

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            self.openLoginPopup('js-loginPopup');

            return false;
        });
    },

	inlineYoutube: function () {
		jQuery( document ).on( "click", ".youtube__player" , function() {
			var video_id = jQuery( this ).find( '.youtube-inline-player' ).data("youtube");
			jQuery( this ).addClass('played');
			jQuery( this ).html('<iframe src="https://www.youtube.com/embed/' + video_id + '?autoplay=1&mute=0&rel=0&" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="parent-background"></iframe>');
		});
	},
	

	isVisible ( $element ) {
		var elementTop = $element.offset().top;
		var elementBottom = elementTop + $element.outerHeight();
	  
		var viewportTop = jQuery(window).scrollTop();
		var viewportBottom = viewportTop + jQuery(window).height();

		return elementBottom > viewportTop && elementTop < viewportBottom;
	},

	printPage() {
		jQuery( document ).on('click', '.js-printPage', function(e) {
			window.print();
		});
	},

	showMoreArticles() {
		jQuery( document ).on('click', '.js-showMore', function(e) {
			e.preventDefault();
			console.log("asd");
			jQuery( this ).closest( 'section' ).find( 'ul .d-none' ).removeClass( 'd-none' );
			jQuery( this ).remove();
			
		});
	},

	moveRating() {
		var self = this;
		if( jQuery( '.js-rating').length ) {

			if ( self.isVisible( jQuery( '.head-info') ) ) {
				jQuery('.head-info__rating').append( jQuery('.js-rating') );
			}
			else {
				jQuery('.js-bottom-rating').append( jQuery('.js-rating') );
			}
		}
	},

	popupBasicCalls() {
		var self = this;

		jQuery(document).on( 'keydown', function(event) {
			if( jQuery( '.login-popup').length ) {
				if (event.key == "Escape") {
					self.closeLoginPopup();
				}
			}
		});

		jQuery( document ).on( 'click', '.login-popup__close', function(event) {
			event.preventDefault();
			self.closeLoginPopup();
		});

		jQuery( document ).on( 'click', '.login-popup__backLayer', function(event) {
			event.preventDefault();
			self.closeLoginPopup();
		});

		jQuery( document ).on( 'click', '.js-openPopup', function(event) {
			event.preventDefault();
			jQuery(this).data( 'which' );

			self.openLoginPopup( jQuery(this).data( 'which' ) );
		});

		self.checkForFormPopup();
	},

	checkForFormPopup: function() {
		var self = this;

		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const recept = urlParams.get( 'receptEmailem' )
		
		if( recept != null ) {
			self.openLoginPopup( 'js-formPopup' );

			// secure
			jQuery( '.js-formPopup form.wpcf7-form [name="validatef"]' ).val( 'f08eb867d149046d0402b7e46d0e88ad' );
		}
	},

	closeLoginPopup() {
		jQuery( 'body' ).removeClass( 'overflow-hidden' );
		jQuery( '.login-popup.active').removeClass( 'active' );

		if( window.location.href.indexOf( '?receptEmailem' ) > -1) {
			window.history.pushState( '', '', location.href.replace( '?receptEmailem', '' ) );
		}
	},

    openLoginPopup(type) {
        jQuery('body').addClass('overflow-hidden');

        var $popup = jQuery(`.login-popup.${type}`);

        if ($popup.length) {
            console.log('Adding active class to popup');
            $popup.addClass('active');
        }
    },


	iLikePost() {
		var self = this;

		jQuery( document ).on('click', '.js-iLikePost, .js-cooked', function(e) {
			e.preventDefault();

			let cooked = jQuery( this ).hasClass( "js-cooked" );

			let $button = jQuery( this );

			let post_id = jQuery( this ).data( 'post' );

			let send_data = {
				id : post_id, 
				action:'i_like_post', 
				key:'YAi2NOzsOi1hnnq6RHeo7EdIykXxTQguCZ1ybBa33kjYP0'
			};

			if( cooked ) {
				send_data.cooked = 1;
			}

			jQuery.ajax({
				type: "POST",
				url: sikmoVars.ajax_url,
				data: send_data,
				success: function(data){
					if( data.data.status == "error" ) {
						self.openLoginPopup( 'js-loginPopup' );
					}

					if( !cooked ) {
						$button.html( data.data.text );
					}
					
					if(  data.data.status == "saved" ) {
						$button.addClass('saved');
					}
					else {
						$button.removeClass('saved');
					}

				}
			});
		});
	},

	
	
	iLikeTutorial() {
		var self = this;

		var buttonClass = '.js-iLikeTutorial';
		var $button 	= jQuery( buttonClass );

		if( ! $button.length ) {
			return false;
		}

		var post_id 	= $button.attr( 'data-post' );
		var send_data 	= {
			id: post_id, 
			action: 'iLikeTutorial', 
			getLiked: 1, 
			key: '2970c12005d2cfedc11232a90996c886'
		};

		var btnText = helpers.sessionStorage( `tutLiked_${post_id}` );

		if( btnText ) {
			$button.text( btnText );
		} else {
			jQuery.ajax({
				type: 'POST',
				url: sikmoVars.ajax_url,
				data: send_data,
				success: function(response){
					if( response.data.status == 'saved' ) {
						$button.addClass( 'saved' );
						$button.text( response.data.text );
	
						helpers.sessionStorage( `tutLiked_${post_id}`, response.data.text );
					}
				}
			});
		}

		jQuery( document ).on( 'click', buttonClass, function(event) {
			event.preventDefault();

			if( post_id == -1 ) {
				self.openLoginPopup( 'js-loginPopup' );
				return false;
			}

			if( $button.attr( 'data-liked' ) == 1 ) {
				alert( 'Už byl tvůj hlas uložen.' );
				return false;
			}

			send_data.getLiked = 0;

			jQuery.ajax({
				type: 'POST',
				url: sikmoVars.ajax_url,
				data: send_data,
				success: function(response){
					if( response.data.status == 'error' ) {
						self.openLoginPopup( 'js-loginPopup' );
					} else if( response.data.status == 'saved' ) {
						$button.addClass( 'saved' );
						$button.text( response.data.text );
						$button.attr( 'data-liked', 1 );

						helpers.sessionStorage( `tutLiked_${post_id}`, response.data.text );
					}
				}
			});
		});
	},

	updatePortions: function( update_portions ) {
		var self = this;
		jQuery(document).on("click", ".js-ingredientsPlus", function() {
			self.changeIngrediencesNumbers( 1 );
		});
		jQuery(document).on("click", ".js-ingredientsMinus", function() {
			self.changeIngrediencesNumbers( -1 );
		});
	},	



	changeIngrediencesNumbers: function( update_portions ) {
		let oldportions = parseInt( jQuery( '.js-portions' ).text() );
		if( oldportions == 1 && update_portions == -1 ) {
			return;
		}

		jQuery( ".ingredients__list li span" ).each(function( index ) {
			let modifiedText = jQuery( this ).text();
			modifiedText = modifiedText.replaceAll( '⅓', ".333" );
			modifiedText = modifiedText.replaceAll( '¼ ', ".25" );
			modifiedText = modifiedText.replaceAll( '½', ".5" );
			modifiedText = modifiedText.replaceAll( '\n', "" );
			modifiedText = modifiedText.replaceAll(/([0-9]*[.,/]?)[0-9]+/g, '<span>$&</span>');

			let $line = jQuery( "<div>"+modifiedText+"</div>" );

			$line.find('span').each( function() {
				let numero = jQuery( this ).text();
				numero = numero.replaceAll( ',', "." );
				if( numero.includes("/") ) {
					let numeros = numero.split("/");
					numero = parseInt( numeros[0] ) / parseInt( numeros[1] );
				}

				numero = parseFloat( numero );

				let newIngredient = ( numero / oldportions ) * ( oldportions + update_portions );
				newIngredient = newIngredient.toFixed(1);
				newIngredient = newIngredient.replaceAll( '.0', "" );

				jQuery( this ).text( newIngredient ) ; 

			});
			jQuery(this).html( $line.text() );
		});

		jQuery( '.js-portions' ).text( oldportions + update_portions );
	},







	galleryClose: function () {
		jQuery(document).on("click", ".js-gallery_close_over",function() {
			jQuery( '.gallery__over' ).addClass( 'd-none' );
			jQuery( '.gallery__nav--off' ).removeClass( 'gallery__nav--off' );
		});
	},

	rated: function () {
		jQuery(document).on("click", ".rmp-widgets-container",function() {
			jQuery( this ).remove();
		});
	},

	onloadClass: function () {
		document.querySelector('body').classList.add('loaded');
	},

	touch: function () {
		var self = this;

		var touchClass = self.globals.isTouch === true ? 'touch-device' : 'pointer-device';
		document.querySelector('body').classList.add( touchClass );
	},

	smoothScroll: {
		selector: 'a[href*="#"]:not([href="#"])',
		init: function () {
			var self = this;
			var scroll = new SmoothScroll(self.selector, {
				ignore: '[data-scroll-ignore]',
				topOnEmptyHash: false,
				speed: 650,
				offset: function (anchor, toggle) {
					var headerOffset = jQuery( '.header.header--p-fixed .header__row').outerHeight();

					if( jQuery( anchor ).offset().top < jQuery( window ).scrollTop() + headerOffset ) {
						headerOffset = jQuery( '.header.header--p-fixed' ).css( '--header-height' )
						headerOffset = headerOffset.replace( 'px', '');
					}

					if( !headerOffset ) {
						headerOffset = 0;
					}
	
					return headerOffset;
				},
				updateURL: false,
				easing: 'easeInOutCubic',
			});
		},
	},

	windowPosition: function () {
		return {
			x: window.pageXOffset || document.documentElement.scrollLeft,
			y: window.pageYOffset || document.documentElement.scrollTop,
		};
	},

	windowSizes: function () {
		return {
			width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
			height: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
		};
	},

	onresize() {
		var self = this;
	},

	onscroll() {
		var self = this;

		self.moveRating();
		self.checkResponsHeader();
	},
};

jQuery(function() {
	theme.init();
});

window.addEventListener('scroll', function (e) {
	theme.onscroll();
});

window.addEventListener('resize', function (e) {
	theme.onresize();
});

window.onfocus = function () { 
	theme.globals.isTabActive = true; 
}; 

window.onblur = function () { 
	theme.globals.isTabActive = false; 
}; 